export default "__VITE_ASSET__b437ee18__"